import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import WebsiteFormModal from './WebsiteFormModal';
import WebsiteFormPage from './WebsiteFormPage';
import { convertDollarsToMills } from '../../../utils/helpers/currency';

class WebsiteForm extends Component {
  onFormSubmit(handleHide, vals) {
    const {
      dispatch,
      formAction,
      website,
      websites,
      isModal,
    } = this.props;

    // Refine data sent to backend (cpa/cpc to mills, sandbox as a boolean)
    const websiteData = {
      ...vals.website,
      cpa: parseInt(convertDollarsToMills(vals.website.cpa), 10),
      cpc: parseInt(convertDollarsToMills(vals.website.cpc), 10),
      sandbox: vals.website.sandbox === 'live' ? false : true
    };

    const args = formAction === 'Update' ? [website.uuid, { website: { ...websiteData } }] : [{ website: websiteData }];
    dispatch(setLoader('WebsiteForm'));

    dispatch(PublisherApi.actions[`website${formAction}`].post(...args, (_error, success) => {
      dispatch(removeLoader('WebsiteForm'));
      if (success) {
        let collection = [...websites.data];

        if (formAction === 'Update') {
          collection = [...websites.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });

          if (success.data.uuid) {
            dispatch(PublisherApi.actions.pixel.get({ publisher_website_id: website.uuid }));
          }
        } else if (formAction === 'Create') {
           collection.unshift(success.data);
        }

        dispatch({
          type: PublisherApi.events.websites.actionSuccess,
          syncing: false,
          data: { ...websites, data: collection, meta: { ...websites.meta } }
        });

        if (isModal) { handleHide(); }

        if (formAction === 'Create') {
          dispatch(push(`/publisher/home/websites/${success.data.slug}/pixel`));
        }
      }
    }));
  }

  render() {
    const { website, isModal } = this.props;
    
    return (
      <div>
        {
          isModal ? 
          (
            <WebsiteFormModal onFormSubmit={this.onFormSubmit.bind(this)} />
          ) :
          (
            <WebsiteFormPage onFormSubmit={this.onFormSubmit.bind(this)} website={website} />
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loader, publisher: { websites: { data: websites } }, modal } = state;
  const { isModal } = ownProps;
  const formAction = isModal ? get(modal, 'WebsiteFormModal.props.formAction', null) : ownProps.formAction;
  const website = isModal ? get(modal, 'WebsiteFormModal.props.website', null) : ownProps.website;
  const isLoading = loader.includes('WebsiteForm');

  return { isLoading, websites, website, isModal, formAction };
};

export default connect(mapStateToProps)(WebsiteForm);
